/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
// IMPORT - ELEMENTS
import Loader from './Loader';
// IMPORT - Helpers

/* ===========================
CLASS
=========================== */
class Modal extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
  * Main constructor of Component
  */
  constructor(props) {
    super(props);

    this.state = {
      size: (this.props.size || 'modal-md'),
      title: (props.title || ''),
      cancel: props.cancel,
      buttonSubmitLabel: this.props.buttonSubmitLabel,
      buttonSubmitStyle: (this.props.buttonSubmitStyle || 'btn-primary'),
      buttonSubmitAction: this.props.buttonSubmitAction,
      buttonCloseAction: this.props.buttonCloseAction,
    };

    this.handleCancel = this.handleCancel.bind(this);
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  handleCancel(event) {
    this.state.cancel(event);
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div id="exampleModalLive" className="modal fade show" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLiveLabel" style={{ display: 'block' }}>
        <div className={`modal-dialog ${this.state.size}`} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLiveLabel">{this.state.title}</h5>
              {(!this.props.loading && !this.props.submitted)
                ? (
                  <button onClick={this.handleCancel} type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                )
                : null}
            </div>
            <div className="modal-body">
              {(this.props.loading)
                ? (<Loader />)
                : null}

              {this.props.children}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-rounded btn-secondary" data-dismiss="modal" onClick={this.state.buttonCloseAction} disabled={this.props.loading || this.props.submitted}>Close</button>
              {(this.state.buttonSubmitLabel)
                ? (<button type="button" className={`btn btn-rounded ${this.state.buttonSubmitStyle}`} onClick={this.state.buttonSubmitAction} disabled={this.props.loading || this.props.submitted}>{(this.props.loading || this.props.submitted) ? 'Loading...' : this.state.buttonSubmitLabel}</button>)
                : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
Modal.propTypes = {
  loading: PropTypes.bool,
  submitted: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string,
  cancel: PropTypes.func,
  buttonSubmitLabel: PropTypes.string,
  buttonSubmitStyle: PropTypes.string,
  buttonSubmitAction: PropTypes.func,
  buttonCloseAction: PropTypes.func,
  children: PropTypes.object,
};

/* ===========================
EXPORT
=========================== */
export default Modal;
